import { Button, Colors } from '@user-portal/wikr-components';

import * as S from './styled';

type OutlinedButtonPropsType = {
    children: React.ReactNode;
    onClick: () => void;
    dataLocator?: string;
    mb?: number;
    isLoading?: boolean;
    textColor?: Colors;
};

const OutlinedButton = ({ children, onClick, dataLocator, mb, isLoading, textColor }: OutlinedButtonPropsType) => {
    return (
        <S.Container $mb={mb} $borderRadius={12} $borderColor="border-default">
            <Button
                isLoading={isLoading}
                disabled={isLoading}
                textColor={textColor ?? 'text-main'}
                onClick={onClick}
                dataLocator={dataLocator}
            >
                {children}
            </Button>
        </S.Container>
    );
};

export default OutlinedButton;
